module.exports = __webpack_public_path__ + "static/media/7_nature.f2110250.jpg";